<template>
	<div>
		<div class="wd-m-t-20 wd-m-b-20">
			<div>
				<el-tabs type="border-card" v-model="tabindex" @tab-click="tapTab">
					<el-tab-pane label="我的余额">
						<div class="wd-h-40 wd-lh-40">
							<span>可用余额：</span>
							<span class="wd-font-bold wd-success wd-font-18">{{myinfo.canuseamount|amountFormatter}}</span>
						</div>
						<div class="wd-h-40 wd-lh-40">
							<span>累计充值：</span>
							<span class="wd-font-bold wd-warning wd-font-18">{{myinfo.totalamount|amountFormatter}}</span>
						</div>
					</el-tab-pane>
					<el-tab-pane label="充值记录">
						<el-row class="wd-theme-back wd-h-40 wd-lh-40 wd-theme-333">
							<el-col :span="6" class="wd-text-center">日期</el-col>
							<el-col :span="4" class="wd-text-center">金额</el-col>
							<el-col :span="6" class="wd-text-center">状态</el-col>
							<el-col :span="8" class="wd-text-center">备注</el-col>
						</el-row>
						<div v-if="wddatalist[0].cnt>0">
							<el-row class=" wd-h-40 wd-lh-40 wd-theme-333 wd-border-bottom" v-for="(item,index) in wddatalist[0].detail" :key="index">
								<el-col :span="6" class="wd-text-center">{{item.optdate}}</el-col>
								<el-col :span="4" class="wd-text-center wd-success wd-font-bold">+{{item.realamount|amountFormatter}}</el-col>
								<el-col :span="6" class="wd-text-center">成功</el-col>
								<el-col :span="8" class="wd-text-center">{{item.memo}}</el-col>
							</el-row>
						</div>
						<div v-else>
							<div class="wd-p-20 wd-theme-666 wd-text-center">—— 暂无记录 ——</div>
						</div>
					</el-tab-pane>
					<el-tab-pane label="消费记录">
						<el-row class="wd-theme-back wd-h-40 wd-lh-40 wd-theme-333">
							<el-col :span="6" class="wd-text-center">日期</el-col>
							<el-col :span="4" class="wd-text-center">金额</el-col>
							<el-col :span="6" class="wd-text-center">状态</el-col>
							<el-col :span="8" class="wd-text-center">备注</el-col>
						</el-row>
						<div v-if="wddatalist[1].cnt>0">
							<el-row class=" wd-h-40 wd-lh-40 wd-theme-333 wd-border-bottom" v-for="(item,index) in wddatalist[1].detail" :key="index">
								<el-col :span="6" class="wd-text-center">{{item.optdate}}</el-col>
								<el-col :span="4" class="wd-text-center wd-theme wd-font-bold">-{{item.realamount|amountFormatter}}</el-col>
								<el-col :span="6" class="wd-text-center">成功</el-col>
								<el-col :span="8" class="wd-text-center">{{item.memo}}</el-col>
							</el-row>
						</div>
						<div v-else>
							<div class="wd-p-20 wd-theme-666 wd-text-center">—— 暂无记录 ——</div>
						</div>
						
					</el-tab-pane>
					<el-tab-pane label="提现记录">
						<!-- <el-row class="wd-theme-back wd-h-40 wd-lh-40 wd-theme-333">
							<el-col :span="6" class="wd-text-center">日期</el-col>
							<el-col :span="4" class="wd-text-center">金额</el-col>
							<el-col :span="6" class="wd-text-center">状态</el-col>
							<el-col :span="8" class="wd-text-center">备注</el-col>
						</el-row>
						<el-row class=" wd-h-40 wd-lh-40 wd-theme-333 wd-border-bottom">
							<el-col :span="6" class="wd-text-center">2020-06-09 10:41:01</el-col>
							<el-col :span="4" class="wd-text-center wd-primary">-100</el-col>
							<el-col :span="6" class="wd-text-center">无</el-col>
							<el-col :span="8" class="wd-text-center">兑换优惠券</el-col>
						</el-row> -->
						<div class="wd-p-20 wd-theme-666 wd-text-center">—— 暂无记录 ——</div>
					</el-tab-pane>
				</el-tabs>
			</div>
			<div></div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'Canuseamount',
	data(){
		return{
			myinfo:{},
			tabindex:0,
			oldtabindex:-1,
			wddatalist:[
				{cnt:-1,page:0,detail:[]},
				{cnt:-1,page:0,detail:[]},
				{cnt:-1,page:0,detail:[]}
			]
		}
	},
	methods:{
		tapTab(){
			if (this.oldtabindex!==this.tabindex){
				this.oldtabindex=this.tabindex;
				this.loadmemrecord();
			}
		},
		loaddata() {
			this.$wd_request('meminfo', {}, true, '.memdetail')
				.then(data => {
					this.myinfo = data.value;
				})
				.catch(data => {
					this.$wd_toast(data.msg, 'error');
				});
		},
		loadmemrecord(){//0充值2消费
			var index=this.tabindex;
			var type=0;
			if (index==0){
				type=0;
			}else if (index==1){
				type=2;
			}
			var cnt=this.wddatalist[index].cnt;
			var page=this.wddatalist[index].page;
			if (cnt==-1){
				page=1;
			}else{
				page++;
			}
			this.wddatalist[index].page=page;
			var indata={
				cnt:cnt,
				page:page,
				type:type
			}
			this.$wd_request("memrecordlist",indata)
			.then(data=>{
				if (cnt==-1){
					this.wddatalist[index].cnt=data.cnt;
				}
				this.wddatalist[index].detail=data.value;
			})
		}
	},
	created() {
		this.loaddata();
		this.loadmemrecord();
	}
};
</script>

<style></style>
